/**
 * Which groups of change are ON for the person reading this basket: the server's word, not a constant.
 *
 * The basket read names an action URL only for a route that is mounted (`views_module`'s
 * `ViewsRuntime.customer_ordering_open`; staff mirrors name none). A group is on only when the adapter implements
 * it AND the read carries that group's URL, so a build deployed ahead of its routes draws no control for them.
 * Headless: no wording, no rule, only which URLs are there.
 *
 *   changes   the read's `add_line_url` (add to basket, quantity, remove, discard)
 *   checkout  the read's `place_order_url` (a basket with lines, at a customer that may place), or its
 *             `send_for_a_price_url` (a basket holding a paper our team prices, spec 32 §5.7)
 *   files     a slot with an `attach_url` (PO-7: the artwork stream's routes)
 *   reorder   implemented; each Orders row then names its own `reorder_url`, and a row without one shows nothing
 */

import {
  NO_BASKET_CAPABILITIES,
  type CustomerBasketCapabilities,
} from "../data/customer-basket-adapter";
import type { CustomerBasketView } from "../data/customer-basket-types";

export function basketCapabilities(
  implemented: CustomerBasketCapabilities,
  basket: CustomerBasketView | null,
): CustomerBasketCapabilities {
  if (basket === null) {
    // Nothing read yet: the one thing that needs no read is reorder, whose rows carry their own URL.
    return { ...NO_BASKET_CAPABILITIES, reorder: implemented.reorder };
  }
  return {
    changes: implemented.changes && basket.actions.add_line_url !== null,
    checkout:
      implemented.checkout &&
      (basket.actions.place_order_url !== null ||
        (basket.actions.send_for_a_price_url ?? null) !== null),
    files:
      implemented.files &&
      basket.lines.some((line) =>
        line.artwork_slots.some((slot) => slot.attach_url !== null),
      ),
    reorder: implemented.reorder,
  };
}
